import type {
  CipherText,
  ProductOpaqueValue,
  QuoteBreakdown,
  FailedProduct,
  TrackingProperties,
  ModifyProduct,
} from "@b2bportal/purchase-api";
import { CallState } from "@hopper-b2b/types";

import type { CartQuoteError } from "../../../types";

export interface PriceChangeType {
  hasDifference?: boolean;
  predictedTotal?: number;
  predictedTotalPerPassenger?: number;
  priceQuoteTotal?: number;
  priceQuoteTotalPerPassenger?: number;
  previousPriceQuoteTotal?: number;
  difference?: number;
  differenceString?: string;
  isIncrease?: boolean;
  acknowledged?: boolean;
  passengerTypeWithPriceChange?: string;
}

export interface CartQuoteContext {
  error?: CartQuoteError;
  priceQuoteCipherText?: CipherText;
  quoteBreakdown?: QuoteBreakdown;
  cartLocked?: boolean;
  modify: ModifyProduct[];
  priceChange?: PriceChangeType;
  products: Array<ProductOpaqueValue>;
  customerEmail?: string;
  unavailableProducts: Array<FailedProduct>;
  retries: number;
  trackingProperties: TrackingProperties;
  callState?: CallState;
}

export const CartQuoteInitialContext: CartQuoteContext = {
  error: undefined,
  priceQuoteCipherText: undefined,
  quoteBreakdown: undefined,
  cartLocked: undefined,
  modify: [],
  priceChange: undefined,
  products: [],
  customerEmail: undefined,
  unavailableProducts: [],
  retries: 0,
  trackingProperties: {},
  callState: CallState.NotCalled,
};
